import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './css/NavBar.module.css';

const LINKS = [
  { to: '/',           label: 'Home' },
  { to: '/services',   label: 'Services' },
  { to: '/about',      label: 'About' },
  // { to: '/tempest',    label: 'Tempest' },
  // { to: '/manicminer', label: 'Manic Miner' },
  { to: '/contact',    label: 'Contact' },
];

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => { setIsOpen(false); }, [location]);

  return (
    <nav className={`${styles.nav} ${scrolled ? styles.navScrolled : ''}`}>

      {/* Logo */}
      <Link to="/" className={styles.logo}>
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          className={styles.logoImg}
        >
          <rect width="32" height="32" rx="8" fill="#38bdf8" />
          {/* Three circuit nodes */}
          <circle cx="8"  cy="7"  r="2.5" fill="#080d1c" />
          <circle cx="16" cy="5"  r="2.5" fill="#080d1c" />
          <circle cx="24" cy="7"  r="2.5" fill="#080d1c" />
          {/* Vertical stems */}
          <line x1="8"  y1="9.5" x2="8"  y2="17" stroke="#080d1c" strokeWidth="2.5" strokeLinecap="round" />
          <line x1="16" y1="7.5" x2="16" y2="21" stroke="#080d1c" strokeWidth="2.5" strokeLinecap="round" />
          <line x1="24" y1="9.5" x2="24" y2="17" stroke="#080d1c" strokeWidth="2.5" strokeLinecap="round" />
          {/* Curve connector */}
          <path d="M8 17 Q8 21 12 21 H20 Q24 21 24 17" stroke="#080d1c" strokeWidth="2.5" strokeLinecap="round" fill="none" />
          {/* Bottom stem */}
          <line x1="16" y1="21" x2="16" y2="27" stroke="#080d1c" strokeWidth="2.5" strokeLinecap="round" />
        </svg>
        <span className={styles.logoText}>
          <span className={styles.logoB}>B</span>yte79
          <span className={styles.logoDot}>.com</span>
        </span>
      </Link>

      {/* Desktop links */}
      <ul className={styles.links}>
        {LINKS.map(({ to, label }) => (
          <li key={to}>
            <Link
              to={to}
              className={`${styles.link} ${location.pathname === to ? styles.linkActive : ''}`}
            >
              {label}
            </Link>
          </li>
        ))}
      </ul>

      {/* Burger */}
      <button
        className={`${styles.burger} ${isOpen ? styles.burgerOpen : ''}`}
        onClick={() => setIsOpen(v => !v)}
        aria-label="Toggle menu"
      >
        <span /><span /><span />
      </button>

      {/* Mobile drawer */}
      <div className={`${styles.drawer} ${isOpen ? styles.drawerOpen : ''}`}>
        <ul className={styles.drawerLinks}>
          {LINKS.map(({ to, label }) => (
            <li key={to}>
              <Link
                to={to}
                className={`${styles.drawerLink} ${location.pathname === to ? styles.linkActive : ''}`}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default NavBar;
